export const multilevelMenuMobile = () => {
  if(document.querySelector('#primaryMenuMobile')) {
    const menuMobileWrapper = document.querySelector('#primaryMenuMobileWrapper');
    const menuMobile = document.querySelector('#primaryMenuMobile');
    const menuMobileLang = document.querySelector('.menu-mobile__lang');
    const subMenuItems = menuMobile.querySelectorAll('.menu-item-has-children');
    const parentItemsLevel1 = document.querySelectorAll('#primaryMenuMobile>li.menu-item-has-children');
    const menuLevel2 = document.querySelector('.menu-mobile__level--2');
    const menuLevel3 = document.querySelector('.menu-mobile__level--3');
    const menuLevelBackBtn = document.querySelectorAll('.menu-mobile__back-icon');

    if(menuMobileLang) {
      menuMobile.append(menuMobileLang);
    }

    if(subMenuItems) {
      subMenuItems.forEach((item) => {
        const link = item.firstElementChild;
        const arrow = document.createElement('span');

        arrow.classList.add('menu-item-arrow');
        link.prepend(arrow);
      });
    }

    if(menuLevelBackBtn) {
      menuLevelBackBtn.forEach((btn) => {
        const menuLevelWrapper = btn.parentNode.parentNode;
        const menuLevelContent = menuLevelWrapper.querySelector('.menu-mobile__level-content');

        btn.addEventListener('click', (e) => {
          menuLevelWrapper.classList.remove('menu-level-open');
          menuLevelContent.innerHTML = '';
          menuLevelWrapper.style.minHeight = '';
        });
      });
    }

    const passSubmenuToNextLevel = () => {
      const parentItemsLevel2 = menuLevel2.querySelectorAll('li.menu-item-has-children');

      if(parentItemsLevel2) {
        parentItemsLevel2.forEach((item) => {
          item.addEventListener('click', (e) => {
            const currentLink = e.target.parentNode;
            const submenu = currentLink.nextElementSibling;
            const icon = currentLink.querySelector('.menu-icon');
            const menuLevel2Height  = document.querySelector('.menu-mobile__level--2').offsetHeight;

            e.preventDefault();

            if (submenu.classList.contains('sub-menu')) {
              const menuTitle3 = menuLevel3.querySelector('.menu-mobile__level-header');
              const menuContent3 = menuLevel3.querySelector('.menu-mobile__level-content');
    
              menuTitle3.innerHTML = '';
              menuTitle3.append(icon.cloneNode(true));
              menuTitle3.append(currentLink.innerText);
              menuContent3.append(submenu.cloneNode(true));
              menuLevel3.style.minHeight = `${menuLevel2Height}px`;
              menuLevel3.classList.add('menu-level-open');
            } 
          });
        });
      }
    }

    if(parentItemsLevel1) {
      parentItemsLevel1.forEach((item) => {
        const link = item.firstElementChild;
        const arrow = link.querySelector('.menu-item-arrow');

        arrow.addEventListener('click', (e) => {
          const currentLink = e.target.parentNode;
          const submenu = currentLink.nextElementSibling;
          const menuMobileHeight  = document.querySelector('#primaryMenuMobileWrapper').offsetHeight;

          e.preventDefault();

          if (submenu.classList.contains('sub-menu')) {
            const menuContent2 = menuLevel2.querySelector('.menu-mobile__level-content');
  
            menuContent2.append(submenu.cloneNode(true));
            passSubmenuToNextLevel();
            menuLevel2.style.minHeight = `${menuMobileHeight + 70}px`;
            menuLevel2.classList.add('menu-level-open');
          } 
        });
      });
    }
  }
}

export const menuMobileInit = () => {
  const menu = document.querySelector('.menu-mobile');
  const toggler = document.querySelector('.menu-mobile__toggler');
  const menuLevel1 = document.querySelector('.menu-mobile__level--1');

  if(menu && toggler) {
    toggler.addEventListener('click', () => {
      menu.classList.toggle('menu-mobile--open');
      menuLevel1.classList.toggle('menu-level-open');
      document.body.classList.toggle('menu-open');
    });
  }
}